import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';

import {
  RepoAuthorization,
  RepoAuthorizationSchema,
  validationRepoAuthorization
} from './RepoAuthorizationExtension';

export const RepoAuthorizationFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    component: RepoAuthorization,
    name: 'RepoAuthorization',
    schema: RepoAuthorizationSchema,
    validation: validationRepoAuthorization
  }),
);
